import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ILesson } from 'interface/lesson';
import { fetchLesson } from 'services/lesson';

interface IState {
  lesson: ILesson;
  enableLessonMenu: boolean;
  showLessonMenu: boolean;
  canReplyComment: boolean;
  activeCourseId: number;
}

const initialState: IState = {
  lesson: null,
  canReplyComment: false,
  enableLessonMenu: false,
  showLessonMenu: false,
  activeCourseId: null,
};

export const getLesson = createAsyncThunk('lesson/fetch', (lessonId: number) => fetchLesson(lessonId));

const lesson = createSlice({
  name: 'lesson',
  initialState,
  reducers: {
    disableMenu: (state) => {
      state.enableLessonMenu = false;
    },
    enableMenu: (state) => {
      state.enableLessonMenu = true;
    },
    toggleShowMenu: (state) => {
      state.showLessonMenu = !state.showLessonMenu;
    },
    enableToastVideoQuality: (state) => {
      state.activeCourseId = null;
    },
    disableToastVideoQuality: (state, action) => {
      state.activeCourseId = action.payload.courseId;
    },
    clearLessonState: (state) => {
      state.lesson = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLesson.fulfilled, (state, action) => {
      state.lesson = action.payload;
    });
  },
});

export const {
  disableMenu,
  enableMenu,
  toggleShowMenu,
  enableToastVideoQuality,
  disableToastVideoQuality,
  clearLessonState,
} = lesson.actions;
export default lesson.reducer;
